<!--
	弹窗组件 
	function:主要用于后台回调返回后提示错误信息
	author:hexd
	date:2017-12-13 
	ref:muse-ui
-->
<template>
  <div>
		<mu-dialog dialogClass='pop' :open="display" @close="close">
			<div class="title" v-if='false'>{{title}}</div>
      <div class="msg" v-html = "CancelOrderMsg" v-if=" msg == '取消订单openPop' " ></div>
      <div class="msg" v-else="" > {{ msg }} </div>
			<div class="btns" v-if='onlyOk'>
         <a class="btn center" @click="close">确定</a>
			</div>
			<div class="btns" v-else>
				 <a class="btn left" @click="close">取消</a>
         <a class="btn right" @click="ok">确定</a>
			</div>
		</mu-dialog>
  </div>
</template>

<script>
	export default {
		data () {
			return {	
				CancelOrderMsg:'<div>该订单已使用的K币、代金券、储值金额将在24小时内返还至您的账户</div>'+
					"<div style='height: 0.15rem;'></div>"+
					'<div>已支付的金额将返还原支付渠道，最迟在15个工作日到账</div>'+
					"<div style='height: 0.15rem;'></div>"+
					'<div>订单取消后<span style="color:red">无法恢复</span>，如有需要请重新预订</div>',



			}
		},
		props: {
			//标题
			title: {
				type: String,
				default: '默认标题',
			},
			//是否展示
			display:{
				type: Boolean,
				default: true
			},
			//提示内容
			msg:{
				type: String,
				default: '默认信息',
			},
			onlyOk:{
				type: Boolean,
				default: false
			}
		},
		methods: {
			ok(){
				this.$emit('okHandler')
			},
			close(){
				this.$emit('closeHandler')
			}
		},
		computed: {

		}
	}
</script>

<style lang="less" scoped>
	@import "../assets/theme.less";
	.title{
		color: #333333;
		font-size: 0.32rem;
    text-align: center;
    height: 1.12rem;
    line-height: 1.12rem;
	}
	.msg{
    font-size: 0.3rem;
		padding: 0.5rem 0.5rem 0.2rem 0.5rem;
    line-height: 0.36rem;
    color: #333333;
    height: auto;
    word-wrap: break-word;
    text-align:justify;
	}
	.btns{
    display: flex;
    padding: 0.3rem 0.2rem;
		justify-content: space-between;
		.btn{
			border-radius: 4px;
      text-align: center;
      font-size:0.3rem;
      width:2.8rem;
      height: 0.7rem;
      line-height: 0.7rem;
		}
		.left{
			background-color:#cccccc ;
			color:white;
			margin-right: 0.1rem;
		}
		.center{
      margin: 0 auto;
			background-color:#27BA69 ;
			color:white ;
		}
		.right{
			background-color:#27BA69 ;
			color:white ;
			margin-left: 0.1rem;
		}
	}
</style>

<style lang="less">
	@import "../assets/theme.less";
	.pop{
		.mu-dialog-body{
			padding: 0rem;
		}
	}
</style>


// WEBPACK FOOTER //
// pop.vue?30a52de9